import { Injectable } from '@angular/core';

import { LocalStorageService } from '@recruitee/common';
import { RequisitionsGroupKind } from '@recruitee/requisitions-types';

import type { CachedRequisitionListViewState } from '../requisitions.types';
import { RequisitionsListViewType } from '../requisitions.types';

@Injectable()
export class RequisitionsListCacheService {
  private readonly localStorageKey = 'requisitions-list-view-state';

  constructor(private localStorageService: LocalStorageService) {}

  public saveDataInLocalStorage(viewState: Partial<CachedRequisitionListViewState>): void {
    this.localStorageService.set(this.localStorageKey, <CachedRequisitionListViewState>{
      ...this.getLocalStorageData(),
      ...viewState,
    });
  }

  public getLocalStorageData(): CachedRequisitionListViewState {
    return this.localStorageService.get(this.localStorageKey, {
      viewType: RequisitionsListViewType.Tiles,
      collapsedGroups: [],
      groupBy: RequisitionsGroupKind.Status,
    });
  }
}
